import Headroom from "headroom.js";

export function initHeadroom(header) {
	const navBar = document.getElementById("primaryNavigation");

    // Initialize the Headroom library
    let headroom = new Headroom(header, {
        // vertical offset in px before element is first unpinned
        offset: header.offsetHeight,
        // scroll tolerance in px before state changes
        tolerance: 0,
        // or you can specify tolerance individually for up/down scroll
        tolerance: {
            up: 5,
            down: 0,
        },
        // css classes to apply
        classes: {
            // when element is initialised
            initial: "headroom",
            // when scrolling up
            pinned: "headroom--pinned",
            // when scrolling down
            unpinned: "headroom--unpinned",
            // when above offset
            top: "headroom--top",
            // when below offset
            notTop: "headroom--not-top",
            // when at bottom of scoll area
            bottom: "headroom--bottom",
            // when not at bottom of scroll area
            notBottom: "headroom--not-bottom",
            // when frozen method has been called
            frozen: "headroom--frozen",
        },
        // element to listen to scroll events on, defaults to `window`
        scroller: window,
        // callback when pinned, `this` is headroom object
        onPin: function () {},
        // callback when unpinned, `this` is headroom object
        onUnpin: function () {
			if( ! navBar ) return;

            if (navBar.classList.contains("show")) {
                this.elem.classList.remove(this.classes.unpinned);
                this.elem.classList.add(this.classes.pinned);
            } else {
                this.elem.classList.add(this.classes.unpinned);
                this.elem.classList.remove(this.classes.pinned);
            }
        },
        // callback when above offset, `this` is headroom object
        onTop: function () {},
        // callback when below offset, `this` is headroom object
        onNotTop: function () {},
        // callback when at bottom of page, `this` is headroom object
        onBottom: function () {},
        // callback when moving away from bottom of page, `this` is headroom object
        onNotBottom: function () {},
    });

	return headroom;
}
